/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useState } from 'react';
import { useEffect,  } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css'

export default function Navbar() {
const [pathChanged, setPathChanged] = useState(window.location.pathname.split('/')[1])
const [activeTab, setActiveTab]=useState(window.location.pathname.split('/')[1])

useEffect(()=>{
setActiveTab(pathChanged)
},[pathChanged])
const findLocation= (path)=>{
setPathChanged(path)
}

  return (
    <>
      {/* ---------------------------------------------Top NavBar------------------------------------------- */}

      <nav className={`${styles.bg} navbar navbar-expand-lg fixed-top`}>
        <div className="container">
          <Link className={`navbar-brand ${styles.navbarBrand}`} to="/">Mohammed Nabil Portfolio</Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">


            {/* ------------------------------------------Right Nav Items-------------------------------------------*/}
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {/*--------------------------------------- Social Icons---------------------------------------------- */}
              <div className="icons d-flex align-items-center">
                <a href="https://www.facebook.com/modi.nabil.52" target={'_blank'} rel="noreferrer"><i className={`text-white fa-brands ${styles.facebook} fa-facebook mx-3 text-dark`}></i></a>
                <a href="https://github.com/MuhammeedNabil?tab=repositories" target={'_blank'} rel="noreferrer"><i className={`text-white fa-brands ${styles.github} fa-github text-dark`}></i></a>
                <a href="https://www.instagram.com/muhammed_nabil_pop/" target={'_blank'} rel="noreferrer"><i className={`text-white fa-brands ${styles.instagram} fa-instagram mx-3 text-dark`}></i></a>
                <a href="https://www.linkedin.com/in/m-nabilbkr/" target={'_blank'} rel="noreferrer"><i className={`text-white fa-brands ${styles.linkedin} fa-linkedin text-dark`}></i></a>
                <a href="https://twitter.com/MohammeedNabil" target={'_blank'} rel="noreferrer"><i className={`text-white fa-brands ${styles.twitter} fa-twitter text-dark mx-3`}></i></a>
              </div>
              {/*---------------------------------------Contact Nav Button----------------------------------------- */}
              {/* <Link className="nav-link" to='contact'><button onClick={"+201090594627"} className={`btn btn-transparent ${styles.BTN} border border-2 text-white`}>Call Me</button></Link> */}
            </ul>
          </div>
        </div>
      </nav>




      {/* ---------------------------------------------Bottom NavBar------------------------------------------- */}
      <div className={`${styles.navBg} navbar w-100 rounded-top m-auto fixed-bottom bottomNav`}>
        <div className="icons m-auto px-3">

          <Link to='education' className={activeTab === 'education' ? 'activeIcon' : ""} onClick={()=> findLocation('education')}><i className={`${styles.mainIcons} ${styles.graduation}  text-white fa-solid fa-graduation-cap`} title="Education"></i></Link>

          <Link className={activeTab === 'skills' ? 'activeIcon ms-4' : 'ms-4'} onClick={()=> findLocation('skills')} to='skills' ><i className={`${styles.mainIcons} ${styles.chart}  text-white fa-solid fa-chart-pie`} title="My Skills"></i></Link>

          <Link className={activeTab === 'home' ? 'activeIcon mx-4' : "mx-4"} to='home' onClick={()=> findLocation('home')}><i className={`${styles.mainIcons}  text-white fa-solid fa-house`} title="Home"></i></Link>

          <Link className={activeTab === 'myprojects' ? 'activeIcon me-4' : "me-4"} to='myprojects' onClick={()=> findLocation('myprojects')}><i className={`${styles.mainIcons} ${styles.user} text-white fa-solid fa-list-check`} title="My Projects"></i></Link>

          <Link to='contact' className={activeTab === 'contact' ? 'activeIcon' : ""} onClick={()=> findLocation('contact')}><i className={`${styles.mainIcons} ${styles.card} text-white fa-regular fa-id-card`} title="Contact Me"></i></Link>

        </div>
      </div>
    </>
  )
}
